module.exports = __webpack_public_path__ + "b1cb180abe3e74508c79c07896340a97.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/unimpressed-6.png
// module id = 2369
// module chunks = 0